
interface Options {
  target: string;
  duration: number;
}

export function slideToggle(obj: Options) {
  class SlideToggle {
    targets: NodeListOf<Element>;

    constructor() {
      this.targets = document.querySelectorAll(`.${obj.target}`);
      this.init();
    }

    init() {
      Array.prototype.forEach.call(this.targets, (target) => {
        const trigger = target.querySelector(`.${obj.target}_button`);

        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = e.target.closest(`.${obj.target}`);
          const el = parent.querySelector(`.${obj.target}_content`);
          const botton = parent.querySelector(`.${obj.target}_button`);
          this.slideToggle(botton, el, obj.duration);
        });
      });
    }

    slideUp(el, duration) {
      el.style.height = el.offsetHeight + "px";
      el.offsetHeight;
      el.style.transitionProperty = "height, margin, padding";
      el.style.transitionDuration = duration + "ms";
      el.style.transitionTimingFunction = "ease";
      el.style.overflow = "hidden";
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
      el.style.marginTop = 0;
      el.style.marginBottom = 0;
      setTimeout(() => {
        el.style.display = "none";
        el.style.removeProperty("height");
        el.style.removeProperty("padding-top");
        el.style.removeProperty("padding-bottom");
        el.style.removeProperty("margin-top");
        el.style.removeProperty("margin-bottom");
        el.style.removeProperty("overflow");
        el.style.removeProperty("transition-duration");
        el.style.removeProperty("transition-property");
        el.style.removeProperty("transition-timing-function");
      }, duration);
    }

    slideDown(el, duration) {
      el.style.removeProperty("display");
      let display = window.getComputedStyle(el).display;
      if (display === "none") {
        display = "block";
      }
      el.style.display = display;
      const height = el.offsetHeight;
      el.style.overflow = "hidden";
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
      el.style.marginTop = 0;
      el.style.marginBottom = 0;
      el.offsetHeight;
      el.style.transitionProperty = "height, margin, padding";
      el.style.transitionDuration = duration + "ms";
      el.style.transitionTimingFunction = "ease";
      el.style.height = height + "px";
      el.style.removeProperty("padding-top");
      el.style.removeProperty("padding-bottom");
      el.style.removeProperty("margin-top");
      el.style.removeProperty("margin-bottom");
      setTimeout(() => {
        el.style.removeProperty("height");
        el.style.removeProperty("overflow");
        el.style.removeProperty("transition-duration");
        el.style.removeProperty("transition-property");
        el.style.removeProperty("transition-timing-function");
      }, duration);
    };

    slideToggle(target, el, duration) {
      target.classList.toggle('is-opened');

      if (window.getComputedStyle(el).display === "none") {
        return this.slideDown(el, duration);
      } else {
        return this.slideUp(el, duration);
      }
    };
  }

  new SlideToggle();
}
